// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"caab669e","241":"d482784f","255":"a4acf2fb","558":"1b0103fc","938":"f986e6f7","965":"6dcc2bef"}[chunkId] + ".chunk.css";
};